import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const router =  new Router({
	mode:'',
	routes:[
		{
		  path: '/',
		  redirect: '/index'
		},
    	{
			path: '/index',
			name: 'index',
			component: () => import('@/views/Home.vue'),
			meta: {
			  title: '首页'
			}
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('@/views/Login.vue'),
			meta: {
			  title: '登录'
			}
		},
		{
			path: '/courseIndex',
			name: 'courseIndex',
			component: () => import('@/views/Pages/Course/index.vue'),
			meta: {
			  title: '选课列表'
			}
		},
    	{
			path: '/coursePage',
			name: 'coursePage',
			component: () => import('@/views/Pages/Course/page.vue'),
			meta: {
			  title: '课程介绍'
			}
		},
		{
			path: '/search',
			name: 'search',
			component: () => import('@/views/Pages/Course/search.vue'),
			meta: {
			  title: '搜索'
			}
		},
		{
			path: '/settlement',
			name: 'settlement',
			component: () => import('@/views/Pages/Shopping/settlement.vue'),
			meta: {
			  title: '结算',
			  requireAuth: true
			}
		},
		{
			path: '/myCourses',
			name: 'myCourses',
			component: () => import('@/views/Pages/PersonalCenter/myCourses.vue'),
			meta: {
			  title: '我的课程',
			  requireAuth: true
			}
		},
		{
			path: '/chaper',
			name: 'chaper',
			component: () => import('@/views/Pages/PersonalCenter/chaper.vue'),
			meta: {
			  title: '我的章节',
			  requireAuth: true
			}
		},
		{
			path: '/videosWatch',
			name: 'videosWatch',
			component: () => import('@/views/Pages/Subject/videosWatch.vue'),
			meta: {
			  title: '看视频',
			  requireAuth: true
			}
		},
		{
			path: '/question',
			name: 'question',
			component: () => import('@/views/Pages/Subject/question.vue'),
			meta: {
			  title: '考试',
			  requireAuth: true
			}
		},
		{
			path: '/questionAnalysis',
			name: 'questionAnalysis',
			component: () => import('@/views/Pages/Subject/questionAnalysis.vue'),
			meta: {
			  title: '考试解析',
			  requireAuth: true
			}
		},
		{
			path: '/certView',
			name: 'certView',
			component: () => import('@/views/Pages/Cert/certView.vue'),
			meta: {
			  title: '证书',
			  requireAuth: true
			}
		},
		{
			path: '/myExam',
			name: 'myExam',
			component: () => import('@/views/Pages/PersonalCenter/myExam.vue'),
			meta: {
			  title: '我的考试',
			  requireAuth: true
			}
		},
		{
			path: '/profile',
			name: 'profile',
			component: () => import('@/views/Pages/PersonalInfo/profile.vue'),
			meta: {
			  title: '个人信息',
			  requireAuth: true
			}
		},
		{
			path: '/password',
			name: 'password',
			component: () => import('@/views/Pages/PersonalInfo/password.vue'),
			meta: {
			  title: '修改密码',
			  requireAuth: true
			}
		},
		{
			path: '/purchaseHistory',
			name: 'purchaseHistory',
			component: () => import('@/views/Pages/PersonalCenter/purchaseHistory.vue'),
			meta: {
			  title: '订单列表',
			  requireAuth: true
			}
		},
		{
			path: '/myInvoice',
			name: 'myInvoice',
			component: () => import('@/views/Pages/PersonalCenter/myInvoice.vue'),
			meta: {
			  title: '我的发票',
			  requireAuth: true
			}
		},
		{
			path: '/headerManageList',
			name: 'headerManageList',
			component: () => import('@/views/Pages/PersonalInfo/headerManage/list.vue'),
			meta: {
			  title: '抬头管理列表',
			  requireAuth: true
			}
		},
		{
			path: '/headerManageAdd',
			name: 'headerManageAdd',
			component: () => import('@/views/Pages/PersonalInfo/headerManage/add.vue'),
			meta: {
			  title: '新增发票抬头',
			  requireAuth: true
			}
		},
		{
			path: '/integral',
			name: 'integral',
			component: () => import('@/views/Pages/PersonalInfo/integral.vue'),
			meta: {
			  title: '积分信息',
			  requireAuth: true
			}
		},
		{
			path: '/giftIndex',
			name: 'giftIndex',
			component: () => import('@/views/Pages/Gift/index.vue'),
			meta: {
			  title: '礼品商城',
			  requireAuth: false
			}
		},
		{
			path: '/giftPage',
			name: 'giftPage',
			component: () => import('@/views/Pages/Gift/page.vue'),
			meta: {
			  title: '礼品详情',
			  requireAuth: false
			}
		},
		{
			path: '/giftBuy',
			name: 'giftBuy',
			component: () => import('@/views/Pages/Shopping/giftBuy.vue'),
			meta: {
			  title: '积分兑换',
			  requireAuth: true
			}
		},
		{
			path: '/myExchange',
			name: 'myExchange',
			component: () => import('@/views/Pages/PersonalCenter/myExchange.vue'),
			meta: {
			  title: '我的兑换',
			  requireAuth: true
			}
		},
	]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export  default router;




// WEBPACK FOOTER //
// ./src/router/index.js